import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { INBOUND, OUTBOUND } from 'constants/booking';
import { Row } from 'components/shared/Layout';

import SegmentSummaryColumn from './SegmentSummaryColumn';

const SegmentSummary = ({ newExtras, cancelledExtras }) => (
  <>
    {(newExtras.outbound.length > 0 || newExtras.inbound.length > 0) && (
      <>
        <Row>
          <h2>
            <FormattedMessage id="extras.newExtras" />
          </h2>
        </Row>
        <Row>
          <SegmentSummaryColumn key={OUTBOUND} direction={OUTBOUND} extras={newExtras.outbound} />
          <SegmentSummaryColumn key={INBOUND} direction={INBOUND} extras={newExtras.inbound} />
        </Row>
      </>
    )}
    {(cancelledExtras.outbound.length > 0 || cancelledExtras.inbound.length > 0) && (
      <>
        <Row>
          <h2>
            <FormattedMessage id="extras.cancelledExtras" />
          </h2>
        </Row>
        <Row>
          <SegmentSummaryColumn key={OUTBOUND} direction={OUTBOUND} extras={cancelledExtras.outbound} />
          <SegmentSummaryColumn key={INBOUND} direction={INBOUND} extras={cancelledExtras.inbound} />
        </Row>
      </>
    )}
  </>
);

SegmentSummary.propTypes = {
  newExtras: PropTypes.shape({
    outbound: PropTypes.arrayOf(PropTypes.object),
    inbound: PropTypes.arrayOf(PropTypes.object)
  }),
  cancelledExtras: PropTypes.shape({
    outbound: PropTypes.arrayOf(PropTypes.object),
    inbound: PropTypes.arrayOf(PropTypes.object)
  })
};

export default SegmentSummary;
